function initScripts() {
    initHeader();
    initStretch();
    setComparisonAndFavorites();
    window.modals = new Modals();
    new LkSidebar();
    sliders();
    setTimeout(() => new LkComparisonFilter())
    ordersFilter();
    rating();
    orderSelectionMap();
    initScrollToUp();
    initSelect();
    oneClickBuy();
    initDatePicker();
    initValidate();
    productCardSlider();
    initDsoForm();
    orderReviewModal();
    initProductCardInfo();
    cartDelete();
    stickySumCart();
    informerModal();
    checkCookie();
    initGeoIp();
    initContacts();
    paymentEntity();
    productCompare();
    productFavorite();
    YaMetrika.init();

    if (document.querySelector('.product-files__item.pdf')) {
        const pdfLinks = document.querySelectorAll('.product-files__item.pdf');

        pdfLinks.forEach(pdfLink => {
            pdfLink.setAttribute('href', pdfLink.getAttribute('href') + '?t=' + Date.now())
        })
    }

    if (document.querySelector('.js-search-select')) {
        new Select();
    }

    if (document.querySelector('.js-order-city')) {
        new OrderDelivery();
    }

    if (document.querySelector('.js-dropdown')) {
        const dropdowns = document.querySelectorAll('.js-dropdown');

        dropdowns.forEach(dropdown => {
            new Dropdown(dropdown)
        })
    }
    if (document.querySelector('.wysiwyg__content dl')) {
        const dropdowns = document.querySelectorAll('.wysiwyg__content dl');

        dropdowns.forEach(dropdown => {
            new Dropdown(dropdown, {
                dropdownActiveClass: 'open',
                dropdownTriggerSelector: 'dt',
                dropdownContentSelector: 'dd',
            })
        })
    }
    if (document.querySelector('.js-form-files')) {
        const formFiles = document.querySelectorAll('.js-form-files');

        formFiles.forEach(formFile => {
            new AttachmentFiles(formFile)
        })
    }
    if (document.querySelector('.js-form-files-review')) {
        const formFiles = document.querySelectorAll('.js-form-files-review');

        formFiles.forEach(formFile => {
            new AttachmentFiles(formFile, {
                renderFunction: (constructor, inputElement, fileList) => {
                    const fileListElement = constructor.formFilesElement.querySelector(constructor.fileItemListSelector);

                    const html = fileList.map((file, index) => {
                        let src = URL.createObjectURL(file);

                        return `
                            <li class="form-file__item js-form-file-item" data-id="${index}">
                                <span class="form-file__image">
                                    <img src="${src}" alt="${file.name}" title="${file.name}" width="75" height="75">
                                </span>
                                <button class="form-file__delete js-form-file-delete" type="button">
                                    <svg viewBox="0 0 24 24" width="24" height="24">
                                        <use xlink:href="#close"></use>
                                    </svg>
                                </button>
                            </li>
                        `
                    }).join('')

                    fileListElement.insertAdjacentHTML("beforeend", html);
                }
            })
        })
    }
    if (document.querySelector('.js-form-files-review')) {
        const formFiles = document.querySelectorAll('.js-form-files-review');

        formFiles.forEach(formFile => {
            new AttachmentFiles(formFile, {
                renderFunction: (constructor, inputElement, fileList) => {
                    const fileListElement = constructor.formFilesElement.querySelector(constructor.fileItemListSelector);

                    const html = fileList.map((file, index) => {
                        let src = URL.createObjectURL(file);

                        const error = (file.size / 1024 / 1024 > 5) || (!constructor.accept.includes(file.type.split('/')[1]));

                        if (error) {
                            this.showError();
                        }

                        return `
                            <li class="form-file__item js-form-file-item${error ? ' error' : ''}" data-id="${index}">
                                <span class="form-file__image">
                                    <img src="${src}" alt="${file.name}" title="${file.name}" width="75" height="75">
                                </span>
                                <button class="form-file__delete js-form-file-delete" type="button">
                                    <svg viewBox="0 0 24 24" width="24" height="24">
                                        <use xlink:href="#close"></use>
                                    </svg>
                                </button>
                            </li>
                        `
                    }).join('')

                    fileListElement.insertAdjacentHTML("beforeend", html);
                }
            })
        })
    }
    if (document.querySelector('.js-textarea-limit')) {
        const textareas = document.querySelectorAll('.js-textarea-limit');

        textareas.forEach(textarea => {
            new LimitTextarea(textarea);
        })
    }
    if (document.querySelector('.js-more-list')) {
        const lists = document.querySelectorAll('.js-more-list');

        lists.forEach(list => {
            new MoreList(list);
        })
    }
    if (document.querySelector('.js-more-list-status')) {
        const lists = document.querySelectorAll('.js-more-list-status');

        lists.forEach(list => {
            new MoreList(list, {
                showCount: 1,
                endClass: 'product-card__status-item-more'
            });
        })
    }
    if (document.querySelector('.js-complect-buy-btn')) {
        const btn = document.querySelector('.js-complect-buy-btn');
        const nav = document.querySelector('.js-site-header-actions');
        const btnWrapper = btn.closest('.complect-slider__item-footer');

        function setPos() {
            if (window.innerWidth <= 767) {
                nav.prepend(btn);
            } else {
                btnWrapper.append(btn);
            }
        }

        setPos();
        window.addEventListener('resize', setPos)
    }
    if (document.querySelector('.js-product-to-cart-btn')) {
        const btn = document.querySelector('.js-product-to-cart-btn');
        const nav = document.querySelector('.js-site-header-actions');
        const btnWrapper = btn.closest('.product-to-cart__actions');

        function setPos() {
            if (window.innerWidth <= 767) {
                nav.prepend(btn);
            } else {
                if (btnWrapper) {
                    btnWrapper.prepend(btn);
                }
            }
        }

        setPos();
        window.addEventListener('resize', setPos)
    }
    if (document.querySelector('[data-tabs]')) {
        const tabs = document.querySelectorAll('[data-tabs]');

        tabs.forEach(tab => new Tab(tab));
    }
    if (document.querySelector('.js-header-dropdown') && window.innerWidth <= 767) {
        const dropdowns = document.querySelectorAll('.js-header-dropdown');

        dropdowns.forEach(dropdown => {
            new Dropdown(dropdown, {
                dropdownTriggerSelector: '.js-header-dropdown-trigger span',
                dropdownContentSelector: '.js-header-dropdown-content',
            })
        })
    }

    $(document).on('click', '.product-card a.button.added, #bx_basket_in_header', function () {
        window.__authFormRedirectUrl = window.__realBasketUrl;
    });

    BX.addCustomEvent('OnBasketChange', function () {
        if (localStorage.getItem('firstBasketChange') == 'true' || typeof ym != 'function')
            return;

        ym(53957554, 'reachGoal', 'addToCart');
        localStorage.setItem('firstBasketChange', 'true');
    });

    BX.addCustomEvent('OnBasketChange', async function () {
        if (window.location.href.indexOf('/cabinet/basket/') < 0) {
            const response = await fetch(APP.CHECK_SHOW_ACTION_3_1_URL);
            const json = await response.json();
            const data = json.data;

            if (data && data.result) {
                switch (data.result) {
                    case 'show':
                        modalMessage('Вам доступна акция, выберете одну из мини-печей', 'Стоимость будет пересчитана согласно условиям акции в корзине')
                        break;

                    case 'added':
                        modalMessage('Вам доступна акция', 'Стоимость мини-печи пересчитана согласно условиям акции в корзине')
                        break;
                }
            }
        }
    });

    $(document).on('click', '.continue-to-order-btn-auth', function () {
        window.__authFormRedirectUrl = '/cabinet/order/';
    });

    $(document).on('input', 'input[data-only-digit]', function (e) {
        e.target.value = e.target.value.replace(/[^\d+]+/g, '');
    });
    if (document.querySelector('form.lk-auth__form')) {
        document.querySelector('form.lk-auth__form').addEventListener('submit', e => {
            document.querySelector('form.lk-auth__form button').setAttribute('disabled', '');
            setTimeout(() => {
                document.querySelector('form.lk-auth__form button').removeAttribute('disabled');
            }, 1000);
        })
    }

    // Токен капчи форма 1 клика берёт сама при отправке (oneClickBuy.js),
    // заранее готовить его при открытии модалки не нужно.
    $(document).on('click', '.cart-check__buy-click', function () {
        modals.openModal(null, '#buy-click');
    });
    $(document).on('click', '.product-to-cart__buy-click', function () {
        modals.openModal(null, '#buy-click');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initScripts();
})
